/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import type { ValueType } from 'hems/common/utils';

export const TERMS_CATEGORY = {
  TERMS_OF_SERVICE: 'Terms of Service',
  TERMS_OF_PRIVACY: 'Privacy Policy',
} as const;

export type TermsCategoryValue = ValueType<typeof TERMS_CATEGORY>;

export const TERMS_TYPE = {
  USER: 'USER',
  INSTALLER: 'INSTALLER',
  SITE: 'SITE',
} as const;

export type TermsTypeValue = ValueType<typeof TERMS_TYPE>;
